<template>
  <!-- <div id="addressBook">
    <mt-header fixed :title="$t(title)">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
      <mt-button slot="right" @click="addAddress()">
        <img
          src="../../assets/img/index/ico_tianjia_hangqing.png"
          alt=""
          class="add"
        />
      </mt-button>
    </mt-header>
    <div class="content">
      <ul class="list_main">
        <li
          @click="copy($event, item.host)"
          class="item"
          v-for="(item, index) in CloudList"
        >
          <div class="name">{{ item.name }}</div>
          <div class="info">
            <img class="icon" :src="item.show_img_url" alt="" />
            <div class="txt">
              <div>{{ item.network }}</div>
              <div>{{ item.host }}</div>
            </div>
            <mt-button
              size="small"
              type="danger"
              class="del"
              @click="
                () =>
                  $messagebox({
                    title: $t('提示'),
                    message: $t('确定执行此操作?'),
                    showCancelButton: true,
                  }).then((result) => {
                    // debugger;
                    if (result == 'confirm') {
                      // 调用删除方法
                      DelAddress(item.id);
                    }
                  })
              "
              >{{ $t("删除") }}</mt-button
            >
          </div>
        </li>
      </ul>
    </div>
  </div> -->
  <div id="addressBook">
    <mt-header fixed :title="$t(title)">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
      <mt-button
        v-show="CloudList.length > 0"
        slot="right"
        @click="isedit = !isedit"
      >
        <img src="../../assets/img/addresscopy.png" alt="" class="add" />
      </mt-button>
    </mt-header>
    <!-- 无数据的加载动画 -->
    <!-- <template v-if="CloudList.length <= 0">
      <div class="gif">
        <img
          src="../../assets/img/loading/logoloading.gif"
          style="width: 60px; height: 60px"
        />
      </div>
      <div class="loadingbgc">
        <img
          src="../../assets/img/loadingbg.png"
          style="width: 150px; height: 150px"
        />
      </div>
      <div class="bgc">
        <img
          src="../../assets/img/loading/logbgc.png"
          style="width: 60px; height: 60px"
        />
      </div>
      <div class="nocontent">
        <span> {{ $t("暂无数据") }}</span>
      </div>
      <div class="footer2">
        <button class="btn2" @click="addAddress">{{ $t("新建地址") }}</button>
      </div>
    </template> -->
    <template>
      <div class="addcontent">
        <div class="content" v-for="(item, index) in CloudList" :key="index">
          <span :class="isedit ? 'note2' : 'note'"
            >{{ $t("备注") }} {{ item.remark }}</span
          >

          <div class="detail">
            <input
              type="checkbox"
              @change="dolist()"
              :value="item.id"
              v-model="checkeditem"
              v-show="isedit"
            />
            <div class="center">
              <span class="d1">{{ item.coin }} </span> &nbsp
              <span class="d2">({{ item.coin_name }} )</span> &nbsp &nbsp
              <span class="d3">{{ item.network }} </span>

              <span class="address">{{ item.host }}</span>
            </div>
            <div class="copydetail" @click="copy($event, item.host)">
              <img src="@/assets/img/ico_fuzhi_bzxq_hui.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="isedit">
        <div class="fotleft">
          <input
            type="checkbox"
            @change="total()"
            v-model="checkedAll"
          />&nbsp;&nbsp; {{ $t("全选") }}
        </div>
        <button class="btn" @click="DelAddress">{{ $t("删除") }}</button>
      </div>

      <div class="footer" v-else>
        <button class="btn2" @click="addAddress">{{ $t("新建地址") }}</button>
      </div>
    </template>
  </div>
</template>

<script>
import { formatTime } from "@/utils/index";
import { Toast } from "mint-ui";
import { httpAddressBookLists, httpDelAddress } from "@/api/index";
import { CellSwipe } from "mint-ui";
import handleClipboard from "@/utils/clipboard";
import { nextTick } from "process";
import { toThousandFilter } from "../../filters";
export default {
  data() {
    return {
      title: "",
      CloudList: [],
      wrapperWidth: 0,
      type: 1,
      checkedAll: false, //全选按钮的状态
      checkeditem: [], //多选绑定的值
      isedit: false,
    };
  },
  created() {
    this.checkeditem = [];
  },
  activated() {
    this.checkeditem = [];
    // this.CloudList = [];
    this.isedit = false;
    this.title = this.$route.query.title;
    if (this.title == "云端钱包地址簿") {
      this.type = 1;
      this.getData(1);
    } else {
      this.type = 2;
      this.getData(2);
    }
  },
  mounted() {
    this.wrapperWidth = document.documentElement.clientWidth - 90;
  },
  watch: {
    isedit() {
      this.checkeditem = [];
      this.checkedAll = false;
    },
  },
  methods: {
    // 全选
    total() {
      if (this.checkedAll) {
        this.CloudList.forEach((item) => {
          this.checkeditem.push(item.id);
        });
      } else {
        this.checkeditem = [];
      }
    },

    // 实现反选
    dolist() {
      // this.checkeditem = e.target.value;
      // 判断有无这个元素 没有添加 有点击的时候删除
      // let idx = this.checkeditem.indexOf(id);
      // if (idx > -1) {
      //   this.checkeditem.splice(idx, 1);
      // } else {
      //   this.checkeditem.push(id);
      // }
      if (this.checkeditem.length == this.CloudList.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    },
    copy: function (event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("复制成功"));
          // 复制成功
        },
        () => {
          Toast(this.$t("复制异常"));
          // 复制异常
        }
      );
    },
    addAddress() {
      this.$router.push({ path: "/addAddress", query: { type: this.type } });
    },

    getData: function (type) {
      // 获取地址簿
      httpAddressBookLists({ type: this.type })
        .then((res) => {
          this.CloudList = [];
          this.CloudList = res.data.list;
        })
        .catch(() => {});
    },

    // 删除地址簿信息
    DelAddress: function () {
      if (this.checkeditem.length <= 0) {
        Toast(this.$t("请先勾选地址"));
        return;
      }
      const id = this.checkeditem.toString();

      httpDelAddress({ did: id })
        .then((res) => {
          Toast(this.$t(`${res.msg}`));
          this.checkedAll = false;
          this.checkeditem = [];
          this.getData();
        })
        .catch(() => {});
    },
  },
};
</script>
<!-- <style>
	
</style> -->
<style scoped>
#addressBook {
  width: 100%;
  height: 89%;
  padding-top: 40px;
  /* padding-bottom: 10%; */
}
.addcontent {
  height: 100%;
  /* padding-bottom: 10%; */
  overflow: auto;
}

.add {
  width: 18px;
  height: 18px;
  margin-top: 6px;
}

.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}

.mint-button--default {
  color: #656b79 !important;
}

/* .list_main {
  position: relative;
  -webkit-transition: 1s all ease;
  width: 100%;
} */

/* .item {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
}
.item .name {
  margin-bottom: 10px;
}
.item .info {
  display: flex;
  align-items: center;
}
.item .icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.item .txt {
  flex: 1;
  min-width: 0;
  padding: 0 10px;
} */
.content {
  padding: 10px 8px;
  background-color: #fdfefe;
  color: #cacccb;
  border-bottom: #eaeceb 1px solid;
}
.footer {
  position: relative;
  bottom: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 8%;
  width: 100%;
  background-color: #e6e8e7;
}
.footer2 {
  position: absolute;
  bottom: -34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 9%;
  width: 100%;
  background-color: #e6e8e7;
}
.note {
  display: inline-block;
  margin-bottom: 10px;
  margin-left: 10px;
  font-size: initial;
}
.note2 {
  display: inline-block;
  margin-bottom: 10px;
  margin-left: 21px;
  font-size: initial;
}
.address {
  font-size: small;
  color: #212529;
}
.detail {
  display: flex;
  justify-content: start;
}
.center {
  width: 80%;
  margin-left: 10px;
}
.copydetail {
  position: relative;
  right: -25px;
  top: 20px;
}
.copydetail img {
  width: 15px;
  height: 15px;
}
.d1 {
  color: #212529;
}
.d3 {
  color: #212529;
  background: #e3e4e4;
  font-size: small;
}
.btn {
  width: 30%;
  height: 40px;
  margin-right: 20px;
  border-radius: 30px;
  color: #ffffff;
  background-color: #2f7d96;
}
.fotleft {
  margin-left: 10px;
}
.btn2 {
  width: 70%;
  height: 40px;
  margin: 0 auto;
  border-radius: 30px;
  color: #ffffff;
  background-color: #2f7d96;
}
.bgc {
  position: absolute;
  left: 50%;
  top: 266px;
  transform: translate(-50%);
  width: 60px;
  height: 60px;

  text-align: center;
}
.nocontent {
  margin-top: 20px;
  text-align: center;
}
.gif {
  position: absolute;
  top: 266px;
  width: 60px;
  height: 60px;
  left: 50%;
  transform: translate(-50%);
  z-index: 1;
}
.loadingbgc {
  width: 150px;
  height: 150px;
  margin: 160px auto 0px;
}
</style>
